import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Container,
  Wrapper,
  BackgroundImage,
  Fall,
  SecondaryTitle,
  SecondaryTitleTimes,
  ScrollIndicatorIcon,
  ScrollIndicatorText,
  TitlesSection,
  ScrollIndicatorContainer,
  CardContainer,
  DropDownSection
} from "./landingStyles";
import { TweenMax, Power4, Power1 } from "gsap";
import { withRouter } from "react-router-dom";
import mainLogo from "../../assets/ademars/APxM_logo_Horizontal-03.png"
import legentPlaylistImage from "../../assets/images_1/3_Description/3_Background_Playlist.png"
import ReactPlayer from 'react-player'
import posterImageOne from '../../assets/ademars/1_landing_page/poster-image-1@2x.png'
import posterImageTwo from '../../assets/ademars/1_landing_page/video-poster-2-2@2x.png'
import playIcon from '../../assets/ademars/1_landing_page/play-icon@2x.png'
import canvasImageOne from '../../assets/ademars/1_landing_page/Front_Plate_Detail.png'
import canvasImageTwo from '../../assets/ademars/1_landing_page/Back_Plate_Detail.png'
import watchFront from '../../assets/ademars/1_landing_page/Watch_Front_View.png'
import ReactGa from "react-ga";
import Footer from "../../components/Footer";
import plus from '../../assets/ademars/pin-closed.png'
import minus from '../../assets/ademars/pin-open.png'
import {GrFormClose} from 'react-icons/gr'
import { watchDetailData } from "../../modules/data";
import limitedImage from "../../assets/ademars/Limited_Edition_Footer.png";
import {useWheel, } from "react-use-gesture"

function Landing({ setShowInsrtuctionOverlay, canvasOneHeight, canvasTwoHeight , swiperActiveIndex, playVideoOne, playVideoTwo, playVideoThree, setPlayVideoOne, setPlayVideoTwo, setPlayVideoThree}) {

  const [durationPlayed, setDurationPlayed] = useState(0)
  const [durationPlayedTwo, setDurationPlayedTwo] = useState(0)
  const [durationPlayedThree, setDurationPlayedThree] = useState(0)
  const [showDropDownContent, setShowDropDownContent] = useState(false)
  const [activePin, setActivePin] = useState(null)
  const [activePin2, setActivePin2] = useState(null)
  const [videoTwoMuted, setVideoTwoMuted] = useState(false)


  // let screen = useRef(null);
  let titleSection = useRef(null);
  let scrollIndicatorRef = useRef()

  useEffect(() => {
    let screenWidth = window.innerWidth;
    // TweenMax.to(screen, 0.3, {
    //   css: {
    //     opacity: "1",
    //     pointerEvents: "auto",
    //     ease: Power4.easeInOut,
    //   },
    // }).delay(1.8);
    if (screenWidth < 450) {
      TweenMax.to(titleSection, 0.5, {
        css: {
          opacity: "1",
          paddingTop: "12.3vw",
          pointerEvents: "auto",
          ease: Power4.easeInOut,
        },
      }).delay(2.4);
    } else if (screenWidth < 400) {
      TweenMax.to(titleSection, 0.5, {
        css: {
          opacity: "1",
          paddingTop: "20.3vw",
          pointerEvents: "auto",
          ease: Power4.easeInOut,
        },
      }).delay(2.4);
    } else {
      TweenMax.to(titleSection, 0.5, {
        css: {
          opacity: "1",
          paddingTop: "80px",
          pointerEvents: "auto",
          ease: Power4.easeInOut,
        },
      }).delay(2.4);
    }
    TweenMax.to(scrollIndicatorRef,{
      opacity:1,
      ease: Power1.easeInOut,
    }).delay(3.2)
    // return () => {
    //   TweenMax.to(screen, 1, {
    //     css: {
    //       opacity: "0",
    //       pointerEvents: "none",
    //     },
    //   });
    // };
  }, []);

  useEffect(()=>{
    if(showDropDownContent){
      document.getElementById('dropdown-content').classList.replace('dropdown-hide', 'dropdown-show')
    }else{
      document.getElementById('dropdown-content').classList.replace('dropdown-show', 'dropdown-hide')
    }
  }, [showDropDownContent])

  let wheelOne  = useWheel((e)=>{

    const videoOne = document.getElementById("video-one")
    const videoThree = document.getElementById("video-three")

    // verifyVideoOne(e.velocity)
    // verifyVideoTwo(e.velocity)
    // verifyVideoThree(e.velocity)
    // console.warn(e)

   console.warn("workinf")


  })

  const verifyVideoOne = (velocity = 0) => {
    
    const videoOne = document.getElementById("video-one")
    
    let videoOneFromtop = videoOne.getBoundingClientRect().top
    
    let videoOnefromBottomTrigger = videoOneFromtop < (window.innerHeight/100) * 55
    
    if(velocity < 2){
      if(videoOneFromtop > 100 && videoOnefromBottomTrigger){
        setPlayVideoOne(true)
        // setVideoOneMuted(false)
      }else{
        setPlayVideoOne(false)
        // setVideoOneMuted(true)
      }
    }
  }
  
  const verifyVideoTwo = (velocity = 0) => {
    
    const videoTwo = document.getElementById("video-two")
    
    let videoTwoFromtop = videoTwo.getBoundingClientRect().top
    
    let videoTwofromBottomTrigger = videoTwoFromtop < (window.innerHeight/100) * 55
    
    if(velocity < 2){
      if(videoTwoFromtop > 100 && videoTwofromBottomTrigger){
        setPlayVideoTwo(true)
        // setVideoTwoMuted(false)
      }else{
        setPlayVideoTwo(false)
        // setVideoTwoMuted(true)
      }
    }

 }

 const verifyVideoThree = (velocity = 0) => {
    
  const videoThree = document.getElementById("video-three")
  
  let videoThreeFromtop = videoThree.getBoundingClientRect().top
  
  let videoThreefromBottomTrigger = videoThreeFromtop < (window.innerHeight/100) * 55


  
  if(velocity < 2){
    if(videoThreeFromtop > 100 && videoThreefromBottomTrigger){
      setPlayVideoThree(true)
      // setVideoThreeMuted(false)
      console.warn('workinf')
    }else{
      setPlayVideoThree(false)
      console.warn('not working')
      // setVideoThreeMuted(true)
    }
  }

}

  return (
    <Fragment>
      <Wrapper
      // ref={(ref) => {
      //   screen = ref;
      // }}
      {...wheelOne()}
      >
        <BackgroundImage>
          <Container
          >
            <TitlesSection
            ref={(ref) => {
              titleSection = ref;
            }}
        
          >
            <img src={mainLogo} />
            {/* <Title>Immersive Bourbon Tasting</Title> */}
            {/* <SecondaryTitle>Igniting All 5 Senses</SecondaryTitle> */}
            
          </TitlesSection>
          <ScrollIndicatorContainer ref={ref => {scrollIndicatorRef = ref}}>
           {/* <ScrollIndicatorSection onClick={slideSlide}> */}
               <ScrollIndicatorText>
                  Swipe down to discover more about the watch
               </ScrollIndicatorText>
               <ScrollIndicatorIcon size={25}/>
           {/* </ScrollIndicatorSection> */}
         </ScrollIndicatorContainer>
          </Container>
        </BackgroundImage>
          <Fall>
            <div id="video-one" className='first-player-container'>
            {swiperActiveIndex === 2 &&
              <ReactPlayer url='https://vimeo.com/534629816/f7bd2c2999' 
                width='100%' 
                height='100%' 
                key={'video-one-player'}
                playing={playVideoOne}
                playsinline
                controls
                onStart={()=>{
                    ReactGa.event({
                        category:"Button",
                        action:"Video 1 - Started"
                      })
                    verifyVideoOne()

                }}
                onPause={()=>{
                    ReactGa.event({
                        category:"Button",
                        action:`Video 1 - Paused at ${Math.round(durationPlayed)} seconds`
                      })
                }}
                onPlay={()=>{
                    ReactGa.event({
                        category:"Button",
                        action:`Video 1 - Played at ${Math.round(durationPlayed)} seconds`
                      })
                }}
                onEnded={()=>{
                    ReactGa.event({
                        category:"Button",
                        action:"Video 1 - Completed"
                    })
                }}
                onProgress={(e)=> {
                    setDurationPlayed(e.playedSeconds)
                }}
              />
            }
            </div>
            <SecondaryTitle style={{lineHeight:'0.8', }}>
              ROYAL OAK CONCEPT
            </SecondaryTitle>
            <SecondaryTitleTimes>
              "Black Panther"<br/>Flying Tourbillon
            </SecondaryTitleTimes>
            <p className="para-one">
              <span className="first">Audemars Piguet introduces the first iteration of its Marvel </span> 
              <span className="second">Super Hero watch series. Dedicated to Black Panther’s </span>
              <span className="third">parallel universe, this limited edition of 250 pieces reveals </span>
              <span className="fourth">the Royal Oak Concept’s true power. Discover the watch </span>
              <span className="fifth">and the story behind Audemars Piguet’s partnership with Marvel.</span>
            </p>
            <div id='video-two' className='player-container'>
              {swiperActiveIndex === 2 &&
                <ReactPlayer url='https://player.vimeo.com/534629658/6fadb125c5' 
                width='100%' 
                height='100%' 
                key={'video-two-player'}
                playsinline
                controls
                stopOnUnmount
                playing={playVideoTwo}
                onStart={()=>{
                    setDurationPlayedTwo(0)
                    ReactGa.event({
                        category:"Button",
                        action:"Video 2 - Started"
                    })
                    verifyVideoTwo()
                }}
                onPause={()=>{
                    ReactGa.event({
                        category:"Button",
                        action:`Video 2 - Paused at ${Math.round(durationPlayedTwo)} seconds`
                      })
                }}
                onPlay={()=>{
                    ReactGa.event({
                        category:"Button",
                        action:`Video 2 - Played at ${Math.round(durationPlayedTwo)} seconds`
                      })
                }}
                onEnded={()=>{
                    ReactGa.event({
                        category:"Button",
                        action:"Video 2 - Completed"
                    })
                    setDurationPlayedTwo(0)
                }}
                onProgress={(e)=> {
                    setDurationPlayedTwo(e.playedSeconds)
                    console.warn(e)
                }}
              />
              }
            </div>
            <div id='video-three' className='player-container-second'>
              {swiperActiveIndex === 2 &&
                <ReactPlayer url='https://player.vimeo.com/534631296/051104c4a4' 
                    width='100%' 
                    height='100%'
                    key={'video-three-player'}
                    playing={playVideoThree}
                    playsinline
                    controls
                    onStart={()=>{
                        setDurationPlayedThree(0)
                        ReactGa.event({
                            category:"Button",
                            action:"Video 3 - Started"
                          })
                        verifyVideoThree()
                    }}
                    onPause={()=>{
                        ReactGa.event({
                            category:"Button",
                            action:`Video 3 - Paused at ${Math.round(durationPlayedThree)} seconds`
                          })
                    }}
                    onPlay={()=>{
                        ReactGa.event({
                            category:"Button",
                            action:`Video 3 - Video Played at ${Math.round(durationPlayedThree)} seconds`
                          })
                    }}
                    onEnded={()=>{
                        ReactGa.event({
                            category:"Button",
                            action:"Video 3 - Video Completed"
                        })
                        setDurationPlayedThree(0)
                    }}
                    onProgress={(e)=> {
                        setDurationPlayedThree(e.playedSeconds)
                    }}
                  />
                }
              </div>
              <SecondaryTitle style={{lineHeight:'0.8',}}>
              Watch
            </SecondaryTitle>
            <SecondaryTitleTimes>
              Details
            </SecondaryTitleTimes>
              <div style={{position:'relative', marginTop:'2rem'}}>
                  <img id='canvas-1' src={canvasImageOne} width="100%" />
              </div>
              <div  style={{position:'relative',marginTop:'2rem'}}>
                <img id='canvas-2' src={canvasImageTwo} width="100%" />
              </div>
              <DropDownSection>
                <h2 onClick={()=>setShowDropDownContent(!showDropDownContent)}>{showDropDownContent ?'- Hide ': '+ Show '}details</h2>
                <div id="dropdown-content" className="dropdown-hide">
                  {
                    watchDetailData.map((data,i) => (
                      <ul key={`content-${i.toString()}`} className="list"
                      onClick={()=> data.title === '- HIDE DETAILS' && setShowDropDownContent(false)}
                      >
                        <li>
                          <h4>{data.title}</h4>
                          <p>{data.constent}</p>
                        </li>
                      </ul>
                    )) 
                  }
                </div>
                <img src={limitedImage} style={{width:'100%', display:'block'}} />
              </DropDownSection>
              <div className="end-container">
                <SecondaryTitle style={{width:'84%', color:'white', lineHeight:'0.8'}}>
                  ROYAL OAK CONCEPT
                </SecondaryTitle>
                <SecondaryTitleTimes style={{width:'84%'}}>
                  "Black Panther"<br/>Flying Tourbillon
                </SecondaryTitleTimes>
                <p className="para-two" style={{width:'84%',color:'white'}}>
                  <span className="first">Interested in harnessing the power of Vibranium? </span> 
                  <span className="second">Visit one of our Audemars Piguet boutiques. </span>
                  {/* <span className="third">visit one of our Audemars Piguet boutiques. </span> */}
                </p>
                <div style={{textAlign:"center", width:"100%", marginTop:'2.3rem'}}>
                  <img src={watchFront} width={"85%"} style={{display:"inline"}} />
                </div>
              </div>
          </Fall>
      </Wrapper>
      <Footer/>
    </Fragment>
  );
}

export default withRouter(Landing);


const Pin = ({x, y, cardContent, cardTitle ,canvasHeight, showCard, setActivePin, index}) => {
  return(
    <div>
        <span>
          <img style={{width:'1.1rem',
          position:'absolute',
          left: (canvasHeight / 100) * x,
          top: (canvasHeight / 100) * y,
          cursor:'pointer'
          }} 
          onClick={()=> setActivePin(index)}
          onTouchStart={()=> setActivePin(index)}
          src={showCard ? minus : plus} />
        </span>
        {showCard && <Card setActivePin={setActivePin} cardContent={cardContent} cardTitle={cardTitle} />
        }
    </div>
  )
}


const Card = ({setActivePin, cardTitle, cardContent}) => {

  useEffect(()=>{
    window.addEventListener('scroll', listenScroll, true)
    return () => window.removeEventListener('scroll', listenScroll)
  })

  const listenScroll = () => {
    setActivePin(null)
  }
  return(
    <>
    <div onClick={()=> setActivePin(null)} style={{position:'absolute', zIndex:1,  top:0,backgroundColor:'rgba(0,0,0,0.2)',width:"100%", height:'100%'}}></div>
    <div style={{position:'absolute', top:'50%', left:'50%', transform:'translate(-50%, -50%)',
        width:"70%", height:"70%", backgroundColor:'white', zIndex:2
        }}>
          <CardContainer>
            <div className="close-icon-container">
              <GrFormClose onClick={()=> setActivePin(null)} className="close-icon" />
            </div>
              <p>{cardTitle}</p>
              <ul>
                {cardContent.map((line, i) => (
                  <li key={cardTitle+'line'+i}><strong>-</strong> {line}</li>
                ))}
              </ul>
          </CardContainer>
    </div>
    </>
  )
}